import React from 'react';
import { Skeleton } from 'antd';
import { SkeletonCard, Container } from './styles';
import styled from 'styled-components';

const SkeletonConversionGap = styled.div`
  position: relative;
  width: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SkeletonPercentage = styled.div`
  position: absolute;
  background: #e0e0e0;
  height: 18px;
  width: 35px;
  border-radius: 12px;
  z-index: 10;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: pulse 1.5s ease-in-out infinite;
  
  @keyframes pulse {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.6;
    }
  }
`;

const SummarySkeleton = () => (
  <div style={{ 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    padding: '0 20px',
    width: '100%'
  }}>
    {[1, 2, 3, 4, 5, 6].map((index) => {
      const isLastCard = index === 6;
      return (
        <React.Fragment key={index}>
          <div style={{ flex: 1 }}>
            <SkeletonCard>
              <Skeleton 
                active 
                title={{ width: '60%', style: { margin: '0 auto 8px auto' } }}
                paragraph={{ rows: 1, width: ['40%'], style: { textAlign: 'center', margin: '8px auto 0 auto' } }}
              />
            </SkeletonCard>
          </div>
          {!isLastCard && (
            <SkeletonConversionGap>
              <SkeletonPercentage />
            </SkeletonConversionGap>
          )}
        </React.Fragment>
      );
    })}
  </div>
);

export default SummarySkeleton; 